import { number, string, table } from "@rocicorp/zero";
import { coreFields } from "./shared";

export const file = table("files")
	.columns({
		...coreFields,
		orgId: string().from("org_id"),
		fileName: string().from("file_name"),
		contentType: string().from("content_type"),
		directory: string(),
		fullPath: string().from("full_path"),
		pathPrefix: string().from("path_prefix"),
		size: number(),
		height: number().optional(),
		width: number().optional(),
	})
	.primaryKey("id");
